import Swiper, { Autoplay } from 'swiper';
import { pauseAnimation, resumeAnimation, isAnimationStopped } from "../../../../assets/scripts/extends/cookiesManager";

const initSwiper = () => {
  const logosCarousels = document.querySelectorAll( '.logos-carousel .swiper' );
  logosCarousels.forEach( ( carousel ) => {

    const logosCarouselOptions = {
      modules: [ Autoplay ],
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 0,
      disableOnInteraction: false,
      allowTouchMove: false,
      speed: 3000,
    };

    if (!isAnimationStopped()) {
      logosCarouselOptions.autoplay = {
        delay: 0,
      };
    }

    new Swiper( carousel,  logosCarouselOptions);
  } );
};

window.addEventListener( 'load', initSwiper );
